import window from 'window-or-global';

export const DeviceBreakpoints: { [key: string]: { max: number; min: number } } = {
  mobile: { max: 767.98, min: 0 },
  tablet: { max: 1023.98, min: 768 },
  desktop: { max: 1280.98, min: 1024 },
  'lg-desktop': { max: 999999, min: 1280 }, // lower limit only to avoid breaking existing functionality, to be reviewed in case of issues
  'xl-desktop': { max: 999999, min: 1440 },
};

export type Dimension = {
  width: number;
  height: number;
};

export const getWindowDimension = (): Dimension => {
  if (typeof window === 'undefined' || !window) {
    return { width: 0, height: 0 }; // fallback until hydrated on ssr
  }
  const width = window.innerWidth || window.document?.documentElement.clientWidth || window.document?.body.clientWidth;
  const height = window.innerHeight || window.document?.documentElement.clientHeight || window.document?.body.clientHeight;
  return { width, height };
};

export const isWithinBreakpoint = (breakpoint: string): boolean | undefined => {
  const wd = getWindowDimension();

  if (breakpoint === 'lg-desktop' && wd.width > wd.height && wd.width >= DeviceBreakpoints[breakpoint].min) {
    return true;
  } else if (wd.width <= DeviceBreakpoints[breakpoint].max && wd.width >= DeviceBreakpoints[breakpoint].min) {
    return true;
  }
};

export default function isMobileDevice(): boolean {
  return isWithinBreakpoint('mobile') ?? false;
}

export function isTabletDevice(): boolean {
  return isWithinBreakpoint('tablet') ?? false;
}

export function isDesktop(): boolean {
  return isWithinBreakpoint('desktop') ?? false;
}

export function isLargeDesktop(): boolean {
  return isWithinBreakpoint('lg-desktop') ?? false;
}

export function isXLargeDesktop(): boolean {
  return isWithinBreakpoint('xl-desktop') ?? false;
}
